var map = {
	"./solution_icon1.png": "a648",
	"./solution_icon2.png": "e295",
	"./solution_icon3.png": "fe1f",
	"./solution_icon4.png": "f00a",
	"./solution_icon5.png": "5201",
	"./solution_icon6.png": "a18e",
	"./solution_icon7.png": "b292"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f807e";